var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { isArray, isBoolean, isEmpty, omit } from 'lodash';
import { parseFormDataToObj, requestDummyData, serializeQueryString, snakeCaseObj } from './helpers';
var ThunkKit = /** @class */ (function () {
    function ThunkKit(config) {
        this.apiServices = {};
        this.defaultService = {};
        this.setDummyData(config);
        this.setErrorHandler(config);
        this.setApiServices(config);
    }
    ThunkKit.prototype.query = function (namespace, entitySchema, option) {
        if (entitySchema === void 0) { entitySchema = undefined; }
        if (option === void 0) { option = {}; }
        var config = {
            apiServices: this.apiServices,
            defaultService: this.defaultService,
            dummyData: this.dummyData,
            ErrorHandler: this.ErrorHandler,
        };
        return new QueryHelper(namespace, entitySchema, option, config);
    };
    ThunkKit.prototype.setDummyData = function (config) {
        this.dummyData = config.dummyData || {};
    };
    ThunkKit.prototype.setErrorHandler = function (config) {
        this.ErrorHandler = config.errorHandler;
    };
    ThunkKit.prototype.setApiServices = function (config) {
        var _this = this;
        var hasDefaultService = false;
        var thunkServices = __spreadArray([], __read(config.apiServices), false);
        if (thunkServices.length === 1) {
            thunkServices[0].isDefault = true;
        }
        thunkServices.forEach(function (as) {
            _this.apiServices[as.name] = as;
            if (as.isDefault) {
                _this.defaultService = as;
                hasDefaultService = true;
            }
        });
        if (!hasDefaultService) {
            throw new Error('You need to have at least 1 default API Service');
        }
    };
    return ThunkKit;
}());
export { ThunkKit };
var QueryHelper = /** @class */ (function () {
    function QueryHelper(namespace, entitySchema, option, config) {
        if (entitySchema === void 0) { entitySchema = undefined; }
        if (option === void 0) { option = {}; }
        if (config === void 0) { config = {}; }
        var _this = this;
        this.config = {};
        this.postFormData = function (endpoint, prefix, options) {
            return _this.post(endpoint, prefix, __assign(__assign({ requestConfig: { headers: { 'content-type': 'multipart/form-data' } } }, options), { restfulMethod: 'post' }));
        };
        this.putFormData = function (endpoint, prefix, options) {
            return _this.put(endpoint, prefix, __assign(__assign({ requestConfig: { headers: { 'content-type': 'multipart/form-data' } } }, options), { restfulMethod: 'put' }));
        };
        this.wrapper = function (prefix, cb, options) {
            return createAsyncThunk("".concat(_this.namespace, "/WRAP/").concat(prefix), function (params, thunkAPI) { return __awaiter(_this, void 0, void 0, function () {
                var error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, cb(params, __assign({}, thunkAPI))];
                        case 1: return [2 /*return*/, _b.sent()];
                        case 2:
                            error_1 = _b.sent();
                            if (!(error_1 instanceof this.config.ErrorHandler)) {
                                error_1 = new this.config.ErrorHandler(error_1);
                            }
                            if (((_a = this.queryOption) === null || _a === void 0 ? void 0 : _a.isIgnoreError) || (options === null || options === void 0 ? void 0 : options.isIgnoreError)) {
                                return [2 /*return*/, thunkAPI.rejectWithValue({})];
                            }
                            return [2 /*return*/, thunkAPI.rejectWithValue({
                                    errCode: error_1.customErrCode,
                                    errStatusCode: error_1.statusCode,
                                    messageBag: error_1.messageBag,
                                    contexts: error_1.contexts,
                                    errMsg: error_1.userMsg,
                                })];
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        };
        this.namespace = namespace;
        this.entitySchema = entitySchema;
        this.queryOption = __assign({}, option);
        this.config = config;
    }
    QueryHelper.prototype.fetchOne = function (endpoint, prefix, options) {
        return this.fetchRequest(endpoint, prefix ? "".concat(prefix, "/fetchOne") : 'fetchOne', options);
    };
    QueryHelper.prototype.fetch = function (endpoint, prefix, options) {
        return this.fetchRequest(endpoint, prefix ? "".concat(prefix, "/fetchMany") : 'fetchMany', options);
    };
    QueryHelper.prototype.post = function (endpoint, prefix, options) {
        return this.postRequest(endpoint, prefix ? "".concat(prefix, "/post") : 'post', __assign(__assign({}, options), { restfulMethod: 'post' }));
    };
    QueryHelper.prototype.put = function (endpoint, prefix, options) {
        return this.postRequest(endpoint, prefix ? "".concat(prefix, "/put") : 'put', __assign(__assign({}, options), { restfulMethod: 'put' }));
    };
    QueryHelper.prototype.delete = function (endpoint, prefix, options) {
        var deletePrefix = prefix ? "".concat(this.namespace, "/").concat(prefix, "/delete") : "".concat(this.namespace, "/delete");
        if ((options === null || options === void 0 ? void 0 : options.isCallApiOnly) === true) {
            return this.createApiRequestThunk(endpoint, __assign(__assign({}, options), { restfulMethod: 'delete' }));
        }
        if ((options === null || options === void 0 ? void 0 : options.withoutNormalize) === true) {
            return this.createAsyncThunkWithoutNormalize(deletePrefix, endpoint, __assign(__assign({}, options), { restfulMethod: 'delete' }));
        }
        return this.createAsyncThunkAndNormalize(deletePrefix, endpoint, __assign(__assign({}, options), { restfulMethod: 'delete' }));
    };
    QueryHelper.prototype.fetchRequest = function (endpoint, prefix, options) {
        if ((options === null || options === void 0 ? void 0 : options.isCallApiOnly) === true) {
            return this.createApiRequestThunk(endpoint, options);
        }
        if ((options === null || options === void 0 ? void 0 : options.withoutNormalize) === true) {
            return this.createAsyncThunkWithoutNormalize(prefix, endpoint, options);
        }
        return this.createAsyncThunkAndNormalize(prefix, endpoint, options);
    };
    QueryHelper.prototype.postRequest = function (endpoint, prefix, options) {
        if ((options === null || options === void 0 ? void 0 : options.isCallApiOnly) === true) {
            return this.createApiRequestThunk(endpoint, options);
        }
        if ((options === null || options === void 0 ? void 0 : options.withoutNormalize) === true) {
            return this.createAsyncThunkWithoutNormalize(prefix, endpoint, options);
        }
        return this.createAsyncThunkAndNormalize(prefix, endpoint, options);
    };
    QueryHelper.prototype.createAsyncThunkAndNormalize = function (prefix, endpoint, options) {
        var _this = this;
        if (this.entitySchema === undefined) {
            throw new Error('Normalize Error: Missing schemaEntity declaration. Locate at class constructor');
        }
        return createAsyncThunk("".concat(this.namespace, "/").concat(prefix), function (params, _a) {
            var rejectWithValue = _a.rejectWithValue, getState = _a.getState;
            return __awaiter(_this, void 0, void 0, function () {
                var source, requestData, responseBody, apiResponseData, normalized, payload, e_1, appErr;
                var _b, _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            source = params.source, requestData = params.data;
                            _f.label = 1;
                        case 1:
                            _f.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.makeRequest(endpoint, params, options)];
                        case 2:
                            responseBody = _f.sent();
                            apiResponseData = (((_b = responseBody === null || responseBody === void 0 ? void 0 : responseBody.data) === null || _b === void 0 ? void 0 : _b.data) || []);
                            normalized = normalize(apiResponseData, isArray(apiResponseData) ? [this.entitySchema] : this.entitySchema);
                            if (requestData instanceof FormData) {
                                // @ts-ignore
                                params.data = parseFormDataToObj(requestData);
                            }
                            payload = {
                                normalized: normalized,
                                source: source || ((_c = options === null || options === void 0 ? void 0 : options.fixedParams) === null || _c === void 0 ? void 0 : _c.source),
                                paginator: (_d = responseBody === null || responseBody === void 0 ? void 0 : responseBody.data) === null || _d === void 0 ? void 0 : _d.paginator,
                                isLoadMore: params === null || params === void 0 ? void 0 : params.isLoadMore,
                                apiResponseData: undefined,
                            };
                            if (options === null || options === void 0 ? void 0 : options.includeApiResponseData) {
                                payload.apiResponseData = apiResponseData;
                            }
                            if (options === null || options === void 0 ? void 0 : options.fullResponse) {
                                payload.response = omit(responseBody === null || responseBody === void 0 ? void 0 : responseBody.data, 'data');
                            }
                            return [2 /*return*/, payload];
                        case 3:
                            e_1 = _f.sent();
                            appErr = new this.config.ErrorHandler(e_1);
                            if (((_e = this.queryOption) === null || _e === void 0 ? void 0 : _e.isIgnoreError) || (options === null || options === void 0 ? void 0 : options.isIgnoreError)) {
                                return [2 /*return*/, rejectWithValue({})];
                            }
                            return [2 /*return*/, rejectWithValue({
                                    errCode: appErr.customErrCode,
                                    errStatusCode: appErr.statusCode,
                                    contexts: appErr.contexts,
                                    messageBag: appErr.messageBag,
                                    errMsg: appErr.userMsg,
                                })];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        });
    };
    QueryHelper.prototype.createAsyncThunkWithoutNormalize = function (prefix, endpoint, options) {
        var _this = this;
        return createAsyncThunk("".concat(this.namespace, "/withoutNormalize/").concat(prefix), function (params, _a) {
            var rejectWithValue = _a.rejectWithValue;
            return __awaiter(_this, void 0, void 0, function () {
                var responseBody, apiResponseData, e_2, appErr;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.makeRequest(endpoint, params, options)];
                        case 1:
                            responseBody = _d.sent();
                            apiResponseData = (((_b = responseBody === null || responseBody === void 0 ? void 0 : responseBody.data) === null || _b === void 0 ? void 0 : _b.data) || {});
                            if (options === null || options === void 0 ? void 0 : options.fullResponse) {
                                return [2 /*return*/, responseBody === null || responseBody === void 0 ? void 0 : responseBody.data];
                            }
                            return [2 /*return*/, apiResponseData];
                        case 2:
                            e_2 = _d.sent();
                            appErr = new this.config.ErrorHandler(e_2);
                            if (((_c = this.queryOption) === null || _c === void 0 ? void 0 : _c.isIgnoreError) || (options === null || options === void 0 ? void 0 : options.isIgnoreError)) {
                                return [2 /*return*/, rejectWithValue({})];
                            }
                            return [2 /*return*/, rejectWithValue({
                                    errCode: appErr.customErrCode,
                                    errStatusCode: appErr.statusCode,
                                    messageBag: appErr.messageBag,
                                    contexts: appErr.contexts,
                                    errMsg: appErr.userMsg,
                                })];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        });
    };
    QueryHelper.prototype.createApiRequestThunk = function (endpoint, options) {
        var _this = this;
        return function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest(endpoint, params, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
    };
    QueryHelper.prototype.makeRequest = function (endpoint, params, options) {
        return __awaiter(this, void 0, void 0, function () {
            var dataParam, urlParams, data, apiService, request, shouldUseSnakeCase, url, requestApi;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataParam = params.data, urlParams = __rest(params, ["data"]);
                        data = __assign(__assign({}, dataParam), options === null || options === void 0 ? void 0 : options.fixedData);
                        apiService = this.config.defaultService;
                        if (options === null || options === void 0 ? void 0 : options.service) {
                            apiService = this.config.apiServices[options.service];
                        }
                        else if (this.queryOption.service) {
                            apiService = this.config.apiServices[this.queryOption.service];
                        }
                        request = apiService.axios;
                        shouldUseSnakeCase = apiService.isSnakeCase;
                        if (isBoolean(options === null || options === void 0 ? void 0 : options.isSnakeCase)) {
                            shouldUseSnakeCase = options === null || options === void 0 ? void 0 : options.isSnakeCase;
                        }
                        else if (isBoolean(this.queryOption.isSnakeCase)) {
                            shouldUseSnakeCase = this.queryOption.isSnakeCase;
                        }
                        if (!isEmpty(data)) {
                            if (!(data instanceof FormData)) {
                                if (shouldUseSnakeCase) {
                                    data = snakeCaseObj(data);
                                }
                            }
                        }
                        url = getFullUrl(endpoint, __assign(__assign({}, urlParams), options === null || options === void 0 ? void 0 : options.fixedParams), shouldUseSnakeCase);
                        if (!(options === null || options === void 0 ? void 0 : options.dummyData)) return [3 /*break*/, 2];
                        return [4 /*yield*/, requestDummyData((options === null || options === void 0 ? void 0 : options.restfulMethod) || 'get', url, this.config.dummyData)];
                    case 1: return [2 /*return*/, (_a.sent())];
                    case 2:
                        if (!((options === null || options === void 0 ? void 0 : options.restfulMethod) === 'put' || (options === null || options === void 0 ? void 0 : options.restfulMethod) === 'post')) return [3 /*break*/, 4];
                        requestApi = (options === null || options === void 0 ? void 0 : options.restfulMethod) === 'put' ? request.put : request.post;
                        return [4 /*yield*/, requestApi(url, data, options === null || options === void 0 ? void 0 : options.requestConfig)];
                    case 3: return [2 /*return*/, (_a.sent())];
                    case 4:
                        if (!((options === null || options === void 0 ? void 0 : options.restfulMethod) === 'delete')) return [3 /*break*/, 6];
                        return [4 /*yield*/, request.delete(url, __assign(__assign({}, options === null || options === void 0 ? void 0 : options.requestConfig), { data: data }))];
                    case 5: return [2 /*return*/, (_a.sent())];
                    case 6: return [4 /*yield*/, request.get(url, options === null || options === void 0 ? void 0 : options.requestConfig)];
                    case 7: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    return QueryHelper;
}());
var getUrlParamKeys = function (url) {
    var urlParamRgx = /:([a-zA-Z0-9]+)/g;
    var urlParamKeys = [];
    var matches;
    // eslint-disable-next-line no-cond-assign
    while ((matches = urlParamRgx.exec(url)) !== null) {
        urlParamKeys.push(matches[1]);
    }
    return urlParamKeys;
};
var getFullUrl = function (endpoint, params, isUseSnakeCase) {
    var source = params.source, rest = __rest(params, ["source"]);
    var url = endpoint;
    getUrlParamKeys(url).forEach(function (urlParamKey) {
        // @ts-ignore
        url = url.replace(":".concat(urlParamKey), params[urlParamKey]);
    });
    url += serializeQueryString(__assign({}, rest), { snakeKey: isUseSnakeCase });
    return url;
};
